<div class="header" *ngIf="global_texts">

  <div class="brand-colors-lr"></div>

  <div class="d-flex align-items-start align-items-lg-center p-3">
    <div class="flex-fill">
      <nav class="navbar navbar-expand-lg">
        <div class="container-fluid p-0 gap-3">
          <button class="navbar-toggler collapsed order-1" type="button" data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                  aria-label="Toggle navigation">
            <span> </span>
            <span> </span>
            <span> </span>
          </button>
          <div class="logo px-3 order-2">
            <a role="none">
              <!--<img [src]="global_texts.logo_src" width="200"/>-->
              <img [src]="global_texts.logo_LR_src" width="250" height="50"/>
            </a>
          </div>
          <div class="logout order-3 order-lg-4 flex-fill d-flex justify-content-end gap-3">
            <a *ngIf="role_admin" role="button" (click)="downloadCsv()"
               class="d-flex align-items-center justify-content-center gap-2 btn btn-lined-green">
              <span class="material-symbols-outlined">csv</span>
              <span class="d-none d-md-block" [innerHtml]="global_texts.stats"></span>
            </a>
            <a *ngIf="role_admin" role="button" (click)="downloadNewStats()"
               class="d-flex align-items-center justify-content-center gap-2 btn btn-lined-light-green">
              <span class="material-symbols-outlined">csv</span>
              <span class="d-none d-md-block" [innerHtml]="global_texts.stats_other"></span>
            </a>
            <a role="button" (click)="logout()"
               class="d-flex align-items-center justify-content-center gap-2 btn btn-lined-red">
              <span class="material-icons">logout</span>

              <span class="d-none d-md-block" [innerHtml]="global_texts.logout"></span>
            </a>
          </div>
          <div class="collapse navbar-collapse order-4 order-lg-3" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 small gap-3 align-items-center" *ngIf="menu">
              <li class="nav-item" *ngFor="let item of menu">
                <a class="nav-link link--leda" [routerLink]="item.path" [attr.data-text]="item.label" role="button">
                  <span [innerHtml]="item.label"></span>
                  <!--<svg class="link__graphic link__graphic&#45;&#45;stroke link__graphic&#45;&#45;scribble" width="100%" height="9" viewBox="0 0 101 9"><path d="M.426 1.973C4.144 1.567 17.77-.514 21.443 1.48 24.296 3.026 24.844 4.627 27.5 7c3.075 2.748 6.642-4.141 10.066-4.688 7.517-1.2 13.237 5.425 17.59 2.745C58.5 3 60.464-1.786 66 2c1.996 1.365 3.174 3.737 5.286 4.41 5.423 1.727 25.34-7.981 29.14-1.294" pathLength="1"></path></svg>-->
                </a></li>
            </ul>
          </div>

        </div>
      </nav>
    </div>

  </div>
  <div class="p-3 bg-green color-white">
    <!--      <h1 class="fw-bold mb-0" [innerHtml]="global_texts.header.text_bar"></h1>-->
    <h1 class="fw-bold mb-0" [innerHtml]="header_title"></h1>
  </div>
</div>
